import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SavingscustomdefaultcaseService } from "../shared/savingscustomdefaultcase.service";
import { Savingscustomdefaultcase } from "../shared/savingscustomdefaultcase.model";

import { ConfirmationdialogService } from "../../../utility/shared/confirmationdialog.service";
import { ToasterserviceService } from "../../../utility/shared/toasterservice.service";
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Toastpayload } from "../../../utility/shared/toastpayload";

@Component({
  selector: 'app-savingscustomdefaultcaselist',
  templateUrl: './savingscustomdefaultcaselist.component.html',
  styleUrls: ['./savingscustomdefaultcaselist.component.css']
})
export class SavingscustomdefaultcaselistComponent implements OnInit {

  toast: Toastpayload;
  displayedColumns: string[] = ['Id', 'SavingsId', 'InstallmentNo', 'New'];

  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private savingscustomdefaultcaseService: SavingscustomdefaultcaseService,
    private confirmationdialogService: ConfirmationdialogService,
    private toasterserviceService: ToasterserviceService,
    private router: Router) { }

  ngOnInit() {
    this.getInstallmentChangeList();
    this.dataSource.paginator = this.paginator;
  }

  public AddNew() {
    this.router.navigate(['/savingscustomdefaultcase']);
  }

  getInstallmentChangeList() {
    this.savingscustomdefaultcaseService.FetchInstallmentChangeList().subscribe(data => {
      this.dataSource.data = data;
    })
  }

  Edit(Savings: any) {
    this.router.navigate(['/savingscustomdefaultcase',{Id : Savings.Id, SavingsId : Savings.SavingsId}]);
  }

  
  // Delete with Toastr messsage
  Delete(element: any) {

    this.toast = {
      message: "The Default Savings No. have been deleted",
      title: 'Default Savings No deletion',
      ic: {
        timeOut: 3000,
        closeButton: true,
      } as IndividualConfig,
      type: 'success',
    };

    let title: string = "Confirmation";
    let message: string = "If you continue, the Savings No. will be removed. Are you sure? ";
    let btnOkText: string = "Yes";
    let btnCancelText: string = 'No, Exit';

    this.confirmationdialogService.openModalWithClass(title, message, btnOkText, btnCancelText)
      .subscribe(confirmed =>
      {
        if (confirmed == true) {
          // default case deletion
          this.IUDDeafultCase(element);
        }
        else {

          // console.log(confirmed);
          this.toast.message = 'You are cancelled the default savings No deletion.!'
          this.toast.type = 'warning';
          this.toasterserviceService.showToast(this.toast);
        }
      });
  }

  // centre delete action
  IUDDeafultCase(element: any) {

    this.savingscustomdefaultcaseService.selectedSavingsCustomDefaultCase = new Savingscustomdefaultcase;
    this.savingscustomdefaultcaseService.selectedSavingsCustomDefaultCase.Id = element.Id;  // Id
    this.savingscustomdefaultcaseService.selectedSavingsCustomDefaultCase.SavingsId = element.SavingsId;  // SavingsId
    this.savingscustomdefaultcaseService.selectedSavingsCustomDefaultCase.IsActive = false;  // deactivate
    this.savingscustomdefaultcaseService.selectedSavingsCustomDefaultCase.Flag = 3; // deactivate Flag
    // IUD action
    this.savingscustomdefaultcaseService.IUDDefaultCase(this.savingscustomdefaultcaseService.selectedSavingsCustomDefaultCase)
      .toPromise()
      .then(data => {
        this.router.navigate(['/savingscustomdefaultcaselist']);
        // showing message:
        this.toasterserviceService.showToast(this.toast);
      })
  }
}